module.exports = new __parcel__URL__("antirat_squad_department_level_2.be7cfbe3.png").toString();